import { QueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import type { ApiBackendResponse } from '@nf/types/api';
import { PackPopupType, EventPackPopupStates } from '@nf/types/promotion';
import { cwcRiskFreeBetKeys } from '../hooks/query-keys';

/**
 * Optimistically updates the status of pack popup visibility
 * 
 * ⚠ Notice: You must ensure that the data is saved to the database!
 * @param queryClient - The instance of QueryClient of React Query
 */
const optimisticallyUpdatePackPopupStates = (queryClient: QueryClient, popupTypes: Array<PackPopupType>) => {
	const queryKey = cwcRiskFreeBetKeys.popupStatus(popupTypes);
	queryClient.cancelQueries(queryKey);
	queryClient.setQueriesData<ApiBackendResponse<EventPackPopupStates> | undefined>(queryKey, old => {
		return produce(old, draft => {
			for (const item of draft?.Data ?? []) {
				if (popupTypes.includes(item.PopupType)) {
					item.IsShow = false;
				}
			}
		});
	});
};

export const packPopupStatesService = {
	optimisticallyUpdatePackPopupStates
};